var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-calendar-4",
    d: "M52.5,52.5H42V42H52.5ZM36.75,26.25H26.25v10.5h10.5Zm15.75,0H42v10.5H52.5ZM21,42H10.5V52.5H21Zm15.75,0H26.25V52.5h10.5ZM21,26.25H10.5v10.5H21Zm42-21V63H0V5.25H7.875V7.875a5.25,5.25,0,0,0,10.5,0V5.25h26.25V7.875a5.25,5.25,0,0,0,10.5,0V5.25ZM57.75,21H5.25V57.75h52.5ZM52.5,2.625a2.625,2.625,0,1,0-5.25,0v5.25a2.625,2.625,0,1,0,5.25,0ZM15.75,7.875a2.625,2.625,0,1,1-5.25,0V2.625a2.625,2.625,0,1,1,5.25,0Z",
    fill: "#232b2f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/booking-icon.8d29da5af7c888589e8a82855917a42d.svg";
export { ForwardRef as ReactComponent };